import React from 'react'

import Grid from '@material-ui/core/Grid'
import Dialog, { DialogProps } from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import { withStyles, createStyles, WithStyles } from '@material-ui/core'

import { Omit } from 'types'

interface Props extends Omit<DialogProps, 'classes'> {
  onClose?: () => void
  width?: number | string
  leftChild?: React.ReactChild
  rightChild?: React.ReactChild
  middleChild?: React.ReactChild
}

const styles = createStyles({
  content: {
    position: 'relative',
  },
  header: {
    height: '50px',
    position: 'absolute',
    zIndex: 1,
    top: 0,
  },
})

type InjectedProps = Props & WithStyles<typeof styles>

const Layer: React.SFC<InjectedProps> = ({
  onClose,
  children,
  leftChild,
  rightChild,
  middleChild,
  width,
  classes,
  ...props
}) => (
  <Dialog onClose={onClose} disableBackdropClick {...props}>
    <DialogContent className={classes.content} style={{ padding: 0, width: width || 500 }}>
      {middleChild && (
        <Grid container alignItems="center" className={classes.header}>
          <Grid item>
            {leftChild}
          </Grid>
          <Grid item xs>
            {middleChild}
          </Grid>
          <Grid item>
            {rightChild}
          </Grid>
        </Grid>
      )}
      {children}
    </DialogContent>
  </Dialog>
)

export default withStyles(styles)(Layer)
